<template>
	<div>
		<v-data-table
			:key="renderKey"
			:headers="headersComputed"
			:items="revenueSumItems"
			multi-sort
			sort-by="installation_name"
			:footer-props="{
				'items-per-page-options': [10, 50, 100, -1],
			}"
			:items-per-page="100"
		>
			<template v-slot:[`item.installation_name`]="{ item }" >
				{{ item.installation_name }}
			</template>
			<template v-slot:[`item.product_group`]="{ item }" >
				{{ item.product_group }}
			</template>
			<template v-slot:[`item.sum_of_sold_products`]="{ item }" >
				{{ item.sum_of_sold_products }}
			</template>
			<template v-slot:[`item.sum_of_revenue_gross`]="{ item }" >
				{{ toCurrency(item.sum_of_revenue_gross, currencyFormat.locale, item.order_currency_code) }}
			</template>
			<template v-slot:[`item.transaction_fee`]="{ item }" >
				{{ toCurrency(item.transaction_fee, currencyFormat.locale, item.order_currency_code) }}
			</template>

		</v-data-table>
	</div>
</template>
<script>
// eslint-disable-next-line import/named
import { toCurrency } from '../../helper/format'

export default {
	name: 'RevenueSumReportTable',
	props: [
		'revenueSumItems',
		'loadingData',
	],
	data() {
		return {
			renderKey: 0,
			currencyFormat: {
				locale: 'en-US',
			},
			headers: [
				{
					text: 'Mandator',
					value: 'installation_name',
					selected: true,
					sortable: true,
				},
				{
					text: 'Product Group',
					value: 'product_group',
					selected: true,
					sortable: true,
				},
				{
					text: 'Sold items (amount)',
					value: 'sum_of_sold_products',
					selected: true,
					sortable: true,
					align: 'end',
				},
				{
					text: 'Sum of revenue - gross',
					value: 'sum_of_revenue_gross',
					selected: true,
					sortable: true,
					align: 'end',
				},
				{
					text: 'Sum of Transaction Fees',
					value: 'transaction_fee',
					selected: true,
					sortable: true,
					align: 'end',
				},
			],
		}
	},
	watch: {
		headersComputed: {
			handler() {
				this.renderKey += 1
			},
		},
	},
	computed: {
		headersComputed() {
			return this.headers.filter((header) => {
				if (header.value == 'product_group') {
					return !!((this.revenueSumItems[0] && this.revenueSumItems[0].product_group))
				}
				return true
			})
		},
	},
	methods: {
		toCurrency,
	},

}
</script>
<style>
.dataLoading {
	padding-top: 11px;
}

.lodingDataProgressBar{
	padding: 25px;
}
</style>
